import CCAccessCode from '@/application/health/infrastructure/views/CCAccessCode.vue';
import CCAccessCodeChallenge from '@/application/health/infrastructure/views/CCAccessCodeChallenge.vue';
import { checkApplicationSanity } from '@/application/shared/infrastructure/routeGuards';
import { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

export const healthRouter = {
  path: '/health',
  name: 'Health',
  redirect: {
    name: 'Home'
  },
  children: [{
    path: 'application/:uuid/cc-access-code',
    name: 'CCAccessCode',
    component: CCAccessCode,
    beforeEnter: (to: RouteLocationNormalized, _from: RouteLocationNormalized): NavigationGuardReturn => checkApplicationSanity('hfc_enrollment_token', 'CCAccessCodeChallenge', to.params),
  }, {
    path: 'application/:uuid/cc-access-code/challenge',
    name: 'CCAccessCodeChallenge',
    component: CCAccessCodeChallenge,
  }]
};
